import { FeaturedFlagsUnion } from './FeaturedFlagsContext';

export const getFeaturedFlagsFromJSON = (config: string): FeaturedFlagsUnion[] => {
  try {
    const flags = JSON.parse(config);
    const enabledFlags = Object.keys(flags) as FeaturedFlagsUnion[];

    // Conditionally filter out "ComputeResourceLocal" flag: https://clarifai.atlassian.net/browse/MRK-4936
    if (enabledFlags.includes('ComputeResourceLocal') && flags.ComputeResourceLocal.toString() === '1') {
      return enabledFlags.filter((flag) => flag !== 'ComputeResourceLocal');
    }

    return enabledFlags;
  } catch {
    console.error('Enable to parse JSON with featured flags');

    return [];
  }
};
